import React, { useContext, useState } from "react";
import Card1 from "../components/Card1";
import { ThemeContext } from "../themeProvider";
import Card2 from "../components/Card2";
import Card3 from "../components/Card3";
import Card4 from "../components/Card4";
import Card5 from "../components/Card5";
import Card6 from "../components/Card6";

const Projects = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  const [showMore, setShowMore] = useState(false);

  return (
    <div
      id="projects"
      className={darkMode ? "bg-white text-black" : "bg-gray-900 text-white"}
    >
      <div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4 pt-24 pb-12">
        <h2 className="text-5xl font-bold px-4 md:px-0 text-center">
          Projects
        </h2>
        <h4 className="mt-16 text-3xl font-semibold text-blue-600">
          What I Built
        </h4>
        <div className="mt-8 flex justify-between items-stretch flex-wrap">
          <Card5 />
          <Card1 />
          <Card2 />
          <Card6 />
          {showMore && (
            <>
              <Card4 />
              <Card3 />
            </>
          )}
        </div>
        <div className="mt-6 text-center">
          <button
            onClick={() => setShowMore(!showMore)}
            className="text-blue-600 hover:bg-blue-100 focus:outline-none border border-blue-600 px-4 py-2 rounded-md"
          >
            {showMore ? "Show Less" : "Show More"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Projects;
